import { render } from "./IsNewsRecord.vue?vue&type=template&id=b4780c74&scoped=true"
import script from "./IsNewsRecord.vue?vue&type=script&lang=js"
export * from "./IsNewsRecord.vue?vue&type=script&lang=js"

import "./IsNewsRecord.vue?vue&type=style&index=0&id=b4780c74&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4780c74"]])

export default __exports__